import { render, staticRenderFns } from "./ProfileVerificationModal.vue?vue&type=template&id=42123e9a&scoped=true&"
import script from "./ProfileVerificationModal.vue?vue&type=script&lang=js&"
export * from "./ProfileVerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfileVerificationModal.vue?vue&type=style&index=0&id=42123e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42123e9a",
  null
  
)

export default component.exports